import React from 'react';
import './Workshops.css';
import Jaaidi from '../../img/workshops/Jaaidi.png';
import Marmicode from '../../img/workshops/Marmicode.png';
import Zikes from '../../img/workshops/Zikes.png';
import ANGULARarchitects from '../../img/workshops/ANGULARarchitects.png';
import Ludemann from '../../img/workshops/Ludemann.png';
import Kuncevic from '../../img/workshops/Kuncevic.png';
import AngularConsulting from '../../img/workshops/AngularConsulting.png';

export default class Workshops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workshops: [
        {
          date: '2023, January 20th',
          photo: Jaaidi,
          name: 'Younes Jaaidi',
          position: 'Google Developer Expert & Software Cook',
          logo: Marmicode,
          title: 'A Pragmatic Angular Testing Strategy',
          bookHref: 'https://events.geekle.us/workshops/YounesJaaidi/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop#ticket',
          price: '$297',
          learnMore: 'https://events.geekle.us/workshops/YounesJaaidi/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop',
        },
        {
          date: '2023, February 16th',
          photo: Zikes,
          name: 'Michael Egger-Zikes',
          position: 'Angular Trainer & Consultant',
          // logo: ANGULARarchitects,
          title: 'Angular Architectures with Runtime Modification',
          bookHref: 'https://events.geekle.us/workshops/MichaelEggerZikes/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop#ticket',
          price: '$299',
          learnMore: 'https://events.geekle.us/workshops/MichaelEggerZikes/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop',
        },
        {
          date: '2023, February 16th',
          photo: Ludemann,
          name: 'Christian Lüdemann',
          position: 'Angular consultant and trainer @Lüdemann Consulting APS',
          title: 'Angular Testing',
          bookHref: 'https://events.geekle.us/workshops/ChristianLudemann/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop#ticket',
          price: '$265',
          learnMore: 'https://events.geekle.us/workshops/ChristianLudemann/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop',
        },
        {
          date: '2023, February 21th',
          photo: Kuncevic,
          name: 'Aliaksei Kuncevic',
          position: 'CEO',
          logo: AngularConsulting,
          title: 'Modern Developer Tools',
          bookHref: 'https://events.geekle.us/workshops/AliakseiKuncevic/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop#ticket',
          price: '$219',
          learnMore: 'https://events.geekle.us/workshops/AliakseiKuncevic/?utm_source=geekle&utm_medium=landingpage&utm_campaign=geekle_workshop',
        },
      ]
    }
  }

  renderWorkshops(item, i) {
    return (
      <div className="workshops_item" key={`workshops-${i}`}>
        <div className="workshops_item--header">
          <div className='workshops_item-title_wrap'>
            <p className='workshops_item-title p1'>Workshop #{i + 1}</p>
            <p className='workshops_item-date p2'>{item.date}</p>
          </div>
          <div className='workshops_item-info'>
            <img className='workshops_item-info_img' src={item.photo} alt="" />
            <div className='workshops_item-info_content'>
              <p className="workshops_item_name p1">{item.name}</p>
              <p className="workshops_item_position p2">{item.position}</p>
              <img className='workshops_item_logo' src={item.logo} alt="" />
            </div>
          </div>
        </div>
        <div className='workshops_item-content'>
          <p className='workshops_title p1'>"{item.title}" <a className='button workshops_button--white_border' target='_blank' rel="noreferrer" href={item.learnMore}>Learn more</a></p>
          <div className='workshops_buttons'>
            <a className='button' target='_blank' rel="noreferrer" href={item.bookHref}>Book for {item.price}</a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="workshops_wrap" id='workshops'>
        <div className='container workshops'>
          <h2 className='colorful'>Workshops 🎓</h2>
          <div className="workshops_block">
            {this.state.workshops.map((item, i) => this.renderWorkshops(item, i))}
          </div>
        </div>
      </div>
    )
  }
}